import React from 'react'

const BoardModerator = () => {
    return (
        <div>
            
        </div>
    )
}

export default BoardModerator
